export const REFERRAL_STORAGE_KEY = 'referralCode';

export function parseReferralFromRoute(route) {
  const params = route && route.params ? route.params : {};
  const query = route && route.query ? route.query : {};
  const value =
    params.code ||
    query.code ||
    query.ref ||
    query.referral ||
    query.referral_code ||
    '';
  return String(value).trim();
}

export function saveReferralCode(code) {
  const normalized = String(code || '').trim();
  if (!normalized) {
    return '';
  }
  localStorage.setItem(REFERRAL_STORAGE_KEY, normalized);
  return normalized;
}

export function getStoredReferralCode() {
  const stored = localStorage.getItem(REFERRAL_STORAGE_KEY);
  return stored ? String(stored).trim() : '';
}

export function buildRegistrationPath(code) {
  const normalized = String(code || '').trim();
  if (!normalized) {
    return '/auth/register';
  }
  return `/auth/register/${encodeURIComponent(normalized)}`;
}

export function buildRegistrationUrl(code, origin) {
  const base = (origin || window.location.origin || '').replace(/\/$/, '');
  const normalized = String(code || '').trim();
  if (!normalized) {
    return `${base}/auth/register`;
  }
  return `${base}/auth/register?code=${encodeURIComponent(normalized)}`;
}
